/**
 * Core-100 owner direction 9 — who may END a visit (Finish Work).
 *
 * Mirrors the server (`complete_ticket_with_location`): everyone the shop
 * predicate admits (`canCompleteTickets`), plus a Detail Specialist on a
 * DETAIL-ONLY ticket. A ticket with no work, or any line that is not detail
 * work (unclassified categories count as mechanical), is not theirs to end.
 * The server re-checks the whole visit, split siblings included, under lock;
 * this only decides whether the button is worth showing.
 */
import { categoryWorkFamily } from './multiRole';

export interface FinishAuthorityInput {
  canCompleteTickets: boolean;
  isDetailSpecialist: boolean;
}

export function isDetailOnlyWork(jobs: ReadonlyArray<{ category?: string | null }> | null | undefined): boolean {
  return !!jobs && jobs.length > 0 && jobs.every((j) => categoryWorkFamily(j.category) === 'DETAIL');
}

/** Core-100 direction 9: the Detail Specialist half of the Finish Work gate. */
export function mayFinishDetailWork(
  isDetailSpecialist: boolean,
  jobs: ReadonlyArray<{ category?: string | null }> | null | undefined,
): boolean {
  return isDetailSpecialist && isDetailOnlyWork(jobs);
}

export function mayShowFinishWork(
  p: FinishAuthorityInput,
  jobs: ReadonlyArray<{ category?: string | null }> | null | undefined,
): boolean {
  if (p.canCompleteTickets) return true;
  return mayFinishDetailWork(p.isDetailSpecialist, jobs);
}
